import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[fixedCarouselItem]',
  standalone: true,
})
export class FixedCarouselItemDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
